const taIN= {
    login: {
      title: 'உள்நுழைக',
      sign_in_btn: 'உள்நுழைக'
    },
    bar: {
        logout: 'வெளியேறுக',
        languages: 'மொழிகள்',
        settings: 'அமைப்புகளைத் திறக்கவும்'
    },
    language: {
      name: 'Tamil (IN)',
    },
    attributePage: {
        title: 'பண்புக்கூறுகள் மாற்றங்கள்',
        viewChanges: 'மாற்றங்களைக் காண்க',
        dateTime: 'தேதி',
        notificationType: 'அறிவிப்பு வகை',
        notificationValue: 'அறிவிப்பு மதிப்பு',
        oldValue: 'பழைய மதிப்பு',
        newValue: 'புதிய மதிப்பு',
        accept: 'ஏற்கிறேன்',
        reject: 'மறுக்கிறேன்',
    },
    Home: 'முகப்பு',
    load: 'ஆரம்ப ஏற்றுதலைச் செய்கிறது...',
    Requested: "கோரப்பட்டது",
    Viewed: "பார்க்கப்பட்டது",
    Executing: "செயல்படுத்துகிறது",
    Completed: "முடிக்கப்பட்டது",
    Expired: "காலாவதியாகிவிட்டது",
    Cancelled: "இரத்துசெய்யப்பட்டது",
    Error: "பிழை",
    Rejected: "நிராகரிக்கப்பட்டது",
    error: 'ஏதோ தவறு நடந்துவிட்டது; தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்.',
    displayname: 'காட்சி பெயர்',
    givenname: 'பெயர்',
    surname: 'குடும்பப் பெயர்',
    email: 'மின்னஞ்சல்',
    mail: 'மின்னஞ்சல்',
    name: 'பெயர்',
    firstname: 'பெயர்',
    lastname: 'குடும்பப் பெயர்',
    footer_copyright: 'அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டுள்ளன.'
  };
  
  export default taIN;
  